var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 35,
    viewBox: "0 0 47 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.875 0.5C34.3837 0.5 38.7077 2.29107 41.8958 5.47919C45.0839 8.6673 46.875 12.9913 46.875 17.5C46.875 22.0087 45.0839 26.3327 41.8958 29.5208C38.7077 32.7089 34.3837 34.5 29.875 34.5C25.3663 34.5 21.0423 32.7089 17.8542 29.5208C14.6661 26.3327 12.875 22.0087 12.875 17.5C12.875 12.9913 14.6661 8.6673 17.8542 5.47919C21.0423 2.29107 25.3663 0.5 29.875 0.5ZM29.875 30.25C33.2565 30.25 36.4995 28.9067 38.8906 26.5156C41.2817 24.1245 42.625 20.8815 42.625 17.5C42.625 14.1185 41.2817 10.8755 38.8906 8.48439C36.4995 6.0933 33.2565 4.75 29.875 4.75C26.4935 4.75 23.2505 6.0933 20.8594 8.48439C18.4683 10.8755 17.125 14.1185 17.125 17.5C17.125 20.8815 18.4683 24.1245 20.8594 26.5156C23.2505 28.9067 26.4935 30.25 29.875 30.25ZM4.375 17.5C4.3749 20.1349 5.19249 22.7049 6.71497 24.8554C8.23745 27.0059 10.3898 28.6309 12.875 29.5062V33.9475C5.54375 32.0562 0.125 25.4263 0.125 17.5C0.125 9.57375 5.54375 2.94375 12.875 1.0525V5.49375C7.92375 7.23625 4.375 11.9538 4.375 17.5Z",
    fill: "#2393B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.11cd325afdfa2ea8aecdc1b89e50c52d.svg";
export { ForwardRef as ReactComponent };